<template>
  <v-navigation-drawer app dark color="#333" v-model="drawer">
    <v-img src="@/assets/mcc_white.png" contain height="80" class="mt-8"></v-img>

    <v-divider class="mt-8 mb-2" color="#5f5f5f" />

    <v-list nav>
      <v-list-item-group active-class="light-green darken-3">
        <v-list-item
          v-for="link in mainLinks"
          :key="link.label"
          style="text-decoration: none; color: inherit;"
          :to="link.url"
        >
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ link.label }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>

      <v-list-group prepend-icon="mdi-map-marker-multiple">
        <template v-slot:activator>
          <v-list-item-title>Area</v-list-item-title>
        </template>

        <v-list-item
          v-for="link in areaLinks"
          :key="link.label"
          style="text-decoration: none; color: inherit;"
          :to="link.url"
        >
          <v-list-item-icon class="pl-5">
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ link.label }}</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data: () => ({
    mainLinks: [
      {
        label: "Dashboard",
        icon: "mdi-view-dashboard",
        url: "/"
      },
      {
        label: "User Profile",
        icon: "mdi-account",
        url: "/user"
      },
      {
        label: "Congregation",
        icon: "mdi-table-large",
        url: "/congregation"
      },
      {
        label: "Form",
        icon: "mdi-clipboard-text",
        url: "/form"
      }
    ],
    areaLinks: [
      {
        label: "Slipi",
        url: "/slipi"
      },
      {
        label: "Kwitang",
        url: "/kwitang"
      },
      {
        label: "BSD",
        url: "/bsd"
      },
      {
        label: "Tangerang",
        url: "/tangerang"
      },
      {
        label: "Bekasi",
        url: "/bekasi"
      }
    ]
  }),
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    }
  }
};
</script>
